import { useContext } from "react"
import { UserContext } from "../context/userContext"
import { LoaderMedium } from "./Loaders"

import { gql, useQuery } from "@apollo/client"

export default function MyParticipantsSummary() {
  const userCtx = useContext(UserContext)

  const GET_PARTICIPANTS = gql`
    query myParticipantsStats($staff_id: ID!, $organization_id: ID!) {
      myParticipantsStats(
        staff_id: $staff_id
        organization_id: $organization_id
        type: "my_participants"
      ) {
        currently_assigned
        currently_unassigned
        engaged
        unengaged
        inactive
      }
    }
  `
  const { data, loading } = useQuery(GET_PARTICIPANTS, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    fetchPolicy: "network-only",
    skip: !userCtx,
  })

  if (loading) {
    return (
      <div>
        <LoaderMedium />
      </div>
    )
  }

  return (
    <div className="box-summary">
      <h2>My Participants</h2>
      <ul>
        <li>
          Currently assigned:{" "}
          {` ${data.myParticipantsStats.currently_assigned}`}
        </li>
        <li>Engaged: {` ${data.myParticipantsStats.engaged}`}</li>
        <li>Unengaged: {` ${data.myParticipantsStats.unengaged}`}</li>
      </ul>
    </div>
  )
}
